import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewexamguide',
  templateUrl: './viewexamguide.component.html',
  styleUrls: ['./viewexamguide.component.css']
})
export class ViewexamguideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
